












import {
    defineComponent,
    watch,
} from '@vue/composition-api';
import SdsMobileHeader from '@src/app/mobile/navbar/SdsMobileHeader.vue';
import SdsGlobalHeaderLogo from '@modules/layout/header/components/SdsGlobalHeaderLogo.vue';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import authenticationStoreIndex from '@store/modules/data/authentication/authenticationIndex';
import { RouteName } from '@src/app/router/constants/RouteName';
import { NavigationDataStore } from '@store/modules/navigation';

export default defineComponent({
    setup() {
        const authenticationStore = useVuexStore<typeof authenticationStoreIndex>('data/authentication');
        const logout = authenticationStore.action('logout');
        const user = authenticationStore.getter('user');

        const navigationStore = useVuexStore<NavigationDataStore>('navigation');
        const addMobileRouteActionItems = navigationStore.action('addMobileRouteActionItems');

        watch(user, () => {
            addMobileRouteActionItems({
                [RouteName.App.Home]: [
                    {
                        iconName: 'navigation-search',
                        ariaLabel: 'search',
                        onClick: (_route, router) => {
                            router.push({
                                name: RouteName.Sport.Search,
                            });
                        },
                    },
                    ...(user.value ? [{
                        iconName: 'actions-logout',
                        ariaLabel: 'logout',
                        onClick: () => logout(),
                    }] : []),
                ],
            });
        }, { immediate: true });

        return {
            user,
        };
    },
    components: {
        SdsGlobalHeaderLogo,
        SdsMobileHeader,
    },
});
